import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { memo } from 'react';

export const VersionTag = memo(() => {
  useLanguage();
  return (
    <div 
      className="fixed right-[max(8px,env(safe-area-inset-right))] bottom-[calc(8px+env(safe-area-inset-bottom))] text-[11px] opacity-60 bg-white px-2 py-1 rounded-full shadow-[0_2px_8px_rgba(15,23,42,0.12)] z-50 pointer-events-none select-none"
      aria-hidden="true"
    >
      {translateInterfaceText("v1.1.0 | dev")}</div>
  );
});

VersionTag.displayName = 'VersionTag';
